import { Button, Flex } from "@fluentui/react-northstar";
import React, { ReactNode } from "react";


export interface IFilterNotesPanelProps {
    isMobile: boolean;
    isAnyFilter: boolean;
    filters: ReactNode;
    clearAllFilters: () => void;
}

const FilterNotesPanel: React.FC<IFilterNotesPanelProps> = ({
    isMobile,
    isAnyFilter,
    filters,
    clearAllFilters,
}) => {
    return (
        <Flex column gap="gap.small" hAlign={isMobile ? "stretch" : undefined}>
            <Flex hAlign="end">
                <Button
                    disabled={!isAnyFilter}
                    size="small"
                    content="Wyczyść filtry"
                    onClick={() => clearAllFilters()} />
            </Flex>
            {filters}
        </Flex>
    )
}

export default FilterNotesPanel